import React, { Component } from 'react';
import './RecruitmentLanding.css';
import RecruitmentMain from "./../../../img/recruitment/recruitment_main.png";

export class RecruitmentLanding extends Component {
    render() {
        return (
            <div id="recruitment-top-showcase">
                <img id="recruitment-top-showcase-image" src={RecruitmentMain} alt=""></img>

                <div className="recruitment-showcase-gradient"/>

                <div id="recruitment-top-text">
                  <h1>Recruitment</h1>
                </div>
                
            </div>
        )
    }
}

export default RecruitmentLanding